import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const FAMILY = [
  { slug: "baby-wipes-72ct", label: "Baby Wipes", image: "/products/img_09.png" },
  { slug: "adult-wet-wipes-48ct", label: "Adult Wet Wipes", image: "/products/img_08.png" },
  { slug: "sun-disinfection-wipes-75ct", label: "Disinfection Wipes", image: "/products/img_06.png" },
  { slug: "sun-alcohol-prep-pads-100ct", label: "Alcohol Prep Pads", image: "/products/img_12.png" },
  { slug: "bathroom-tissue-single-roll", label: "Single Roll Tissue", image: "/products/img_04.png" },
  { slug: "kitchen-towel-single-roll", label: "Single Roll Towel", image: "/products/img_11.png" },
];

export default function Family() {
  return (
    <section className="bg-slate-50/60 border-y border-slate-100" data-testid="family-section" id="family">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20 md:py-24">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-[11px] uppercase tracking-[0.3em] text-amber-500 font-bold">The Morning Soft family</p>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-black text-[#0f2a5c] tracking-tight leading-[1.04]">
            More everyday care, from the brand you already trust.
          </h2>
          <p className="mt-4 text-slate-600 max-w-xl mx-auto">
            Wipes, disinfection, hygiene and single-roll refills — thoughtfully made for how modern homes actually live.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {FAMILY.map((f, i) => (
            <motion.div
              key={f.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: (i % 6) * 0.05 }}
              data-testid={`family-item-${f.slug}`}
            >
              <Link to={`/shop/${f.slug}`} className="group block">
                <div className="aspect-square rounded-2xl bg-white border border-slate-100 flex items-center justify-center overflow-hidden hover:border-[#173a7a] hover:shadow-md transition-all">
                  <img
                    src={f.image}
                    alt={f.label}
                    className="max-h-[80%] max-w-[80%] object-contain transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <p className="mt-3 text-center text-sm font-semibold text-slate-800 group-hover:text-[#173a7a] transition-colors">
                  {f.label}
                </p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
